import ReactGA from 'react-ga4';
import classes from './SeeMoreOffers.module.css'
import { BrowserView } from 'react-device-detect';
import { useTranslation } from "react-i18next";

const SeeMoreOffers = (props) => {
    const { t } = useTranslation('common');
    const active = props.buttonIsActive

    const handleButtonClick = () => {
        // Vérifiez si le bouton est actif avant d'envoyer l'événement
        if (active) {
            ReactGA.event({
                category: 'more_offers_click',
                action: 'see_more_offers',
                label: 'See More Offers Button'
            });
        }

        // Appellez la fonction originale onClickMoreOffers
        props.onClickMoreOffers();
    };

    return (
        <>
            <BrowserView >
                <button className={` ${classes.offerButton} `} onClick={handleButtonClick}  disabled={!active} > {active ? t('offer.showMore') : t('offer.noMoreOffer')} </button>
            </BrowserView>
        </>
    )
}

export default SeeMoreOffers